export default __webpack_public_path__ + "static/media/imagem-001.e417177f.jpg";